export enum AmplitudeEvents {
    SESSION_ACCEPTED = 'session_accepted',
    JOURNAL_CREATED = 'journal_created',
    TOS_READ_AND_ACCEPTED = 'tos_accepted',
}

export enum AmplitudeEventsCategories {
    ACTIVATION = 'Activation',
    ACQUISITION = 'Acquistion',
    ANALYTICS = 'Analytics',
}
